module.exports = __webpack_public_path__ + "img/property.2900b277.svg";